/** Matches API `EwcDetailApiModel` / `RegEwcCode` JSON (camelCase). */
export interface IEwcCodeDetail {
    id: string;
    code: string;
    description: string;
    isHazardous: boolean;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type EwcCodeCreatePayload = {
    code: string;
    description: string;
    isHazardous?: boolean;
    isActive?: boolean;
};

export type EwcCodeUpdatePayload = {
    id: string;
    code: string;
    description: string;
    isHazardous: boolean;
};

export const EWC_CREATE_CONFLICT = {
    deletedRestoreAvailable: "ewc.deletedRestoreAvailable",
    duplicateActive: "ewc.duplicateActive",
} as const;
